import { render, staticRenderFns } from "./PenerimaanKasPusat.vue?vue&type=template&id=63e33fd0&"
import script from "./PenerimaanKasPusat.vue?vue&type=script&lang=js&"
export * from "./PenerimaanKasPusat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports